/**
 * クレジットカード登録画面のエラーメッセージ定義
 * GMOトークン化エラーコードに応じたユーザー向けメッセージを返す
 */

const TOKENIZATION_ERROR_MESSAGES = {
  INVALID_CONFIG: '決済システムでエラーが発生しました。問題が続く場合はお問い合わせください。',
  INIT_ERROR: '決済システムでエラーが発生しました。問題が続く場合はお問い合わせください。',
  TOKENIZE_ERROR: 'カード情報をご確認ください。',
  RESPONSE_TIMEOUT: '決済システムとの通信がタイムアウトしました。しばらく待ってから再度お試しください。',
}

const DEFAULT_ERROR_MESSAGE = '決済システムでエラーが発生しました。問題が続く場合はお問い合わせください。'

/**
 * GMOトークン化エラーコードからエラーメッセージを取得
 * @param {string} errorCode - TokenizationErrorのcode
 * @returns {string} ユーザー向けエラーメッセージ
 */
export const getTokenizationErrorMessage = (errorCode) => {
  return TOKENIZATION_ERROR_MESSAGES[errorCode] || DEFAULT_ERROR_MESSAGE
}
